import { reportedTimeToLoggedTime } from "./reportedTimeToLoggedTime";
import { TimeReportAggregatedLoggedTime } from "./TimeReportAggregatedLoggedTime";

export const sumLoggedTimes = (times: TimeReportAggregatedLoggedTime[]): TimeReportAggregatedLoggedTime =>
  times.reduce(
    (acc, curr) => {
      const daily =
        acc.daily || curr.daily
          ? reportedTimeToLoggedTime((acc.daily?.reportedTime ?? 0) + (curr.daily?.reportedTime ?? 0), "DAILY")
          : undefined;
      const hourly =
        acc.hourly || curr.hourly
          ? reportedTimeToLoggedTime((acc.hourly?.reportedTime ?? 0) + (curr.hourly?.reportedTime ?? 0), "HOURLY")
          : undefined;

      return {
        daily,
        hourly,
        isEmpty: (!daily || daily?.isEmpty) && (!hourly || hourly?.isEmpty),
        formattedAmount:
          daily && hourly
            ? `${hourly.formattedAmount} + ${daily.formattedAmount}`
            : daily?.formattedAmount ?? hourly?.formattedAmount ?? "",
      };
    },
    {
      isEmpty: true,
      formattedAmount: "",
    } as TimeReportAggregatedLoggedTime,
  );
